import { AsyncPageRender } from '@components/AsyncComponent';
import { ProtectedRoute } from '@components/Layout/ProtectedRoute';
import { pageModule } from '@components/pageModule';
import { useUser } from '@hooks/useUser';
import { createMemo } from '@packages/react';
import { Route } from '@packages/router';
import React from 'react';
import { Redirect } from 'react-router';
import { ADMIN_TABS } from './admin/Tabs';
import { TABS as CUSTOMER_TABS } from './customer/Tabs';

export const routes$ = {
    Settings: AsyncPageRender(() => pageModule(import('./index'))),
};

const ListTabRedirect = createMemo(
    (): any => {
        const user$ = useUser();

        function getTab() {
            if (
                user$ &&
                (user$.$is('ops') ||
                    user$.$is('admin') ||
                    user$.$is('salesman') ||
                    user$.$is('designer') ||
                    user$.$is('wholesaler'))
            ) {
                return ADMIN_TABS[0].name;
            } else if (user$ && user$.$is('customer')) {
                return CUSTOMER_TABS[0].name;
            }
        }

        return <Redirect to={`/account/settings/${getTab()}`} />;
    },
    {
        displayName: 'ListTabRedirect',
    },
);

function Router() {
    return (
        <>
            <Route name={'Factories.SettingsLogin'} exact path={'/account/settings'} component={ListTabRedirect} />
            <Route
                name={'Account.Settings'}
                exact
                path={'/account/settings/:tab'}
                component={ProtectedRoute(routes$.Settings)}
            />
        </>
    );
}

export default Router;
